import { Component, DestroyRef, OnInit, output } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ClickOutsideDirective } from "blu-utilities";
import { AddClassModifierDirective } from "src/app/core/directives/add-class-modifier.directive";
import { PopupNotification } from "src/app/core/models/notifications";
import { PopupNotificationService } from "src/app/core/services/popup-notification.service";
import { NotificationItemComponent } from "../popup-notification-item/popup-notification-item.component";

@Component({
  selector: "app-popup-notifications",
  templateUrl: "./popup-notifications.component.html",
  styleUrl: "./popup-notifications.component.scss",
  imports: [
    AddClassModifierDirective,
    ClickOutsideDirective,
    NotificationItemComponent,
  ],
})
export class PopupNotificationsComponent implements OnInit {
  readonly closed = output();
  notifications: PopupNotification[] = [];

  constructor(
    private popupNotificationService: PopupNotificationService,
    private destroyRef: DestroyRef,
  ) {}

  ngOnInit(): void {
    this.popupNotificationService
      .getPopupNotifications()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((notifications) => {
        this.notifications = notifications;
      });
  }

  closeNotifications(notification?: PopupNotification) {
    if (notification) {
      this.popupNotificationService.markNotificationAsRead(notification);
    }
    this.closed.emit();
  }
}
